export default "__VITE_ASSET__299de5cb__"